"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preloadValueFlow = preloadValueFlow;
exports.filtersSagas = void 0;

var _effects = require("redux-saga/effects");

var _lodash = _interopRequireDefault(require("lodash"));

var _component = require("../../constants/component");

var filterFormTypes = _interopRequireWildcard(require("./forms/types"));

var _selectors = require("./forms/selectors");

var filterValueTypes = _interopRequireWildcard(require("./value/types"));

var filterFieldsTypes = _interopRequireWildcard(require("./fields/types"));

var _saga = require("./options/saga");

var _actions = require("./value/actions");

var _actions2 = require("./forms/actions");

var _selectors2 = require("./fields/selectors");

var _types4 = require("../partnerEmulation/types");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(preloadValueFlow);

function preloadValueFlow() {
  var action, formId, state, form, filterType, filterParams, preloadFields, _ret, _state, reloadFilterForms, filterTypes, i, reloadFields;

  return regeneratorRuntime.wrap(function preloadValueFlow$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!true) {
            _context2.next = 46;
            break;
          }

          _context2.next = 3;
          return (0, _effects.take)('*');

        case 3:
          action = _context2.sent;

          if (!(action.type === filterFormTypes.MOUNT || action.type === filterFormTypes.UPDATE_PROPS)) {
            _context2.next = 23;
            break;
          }

          formId = action.payload.id;
          _context2.next = 8;
          return (0, _effects.select)();

        case 8:
          state = _context2.sent;
          form = (0, _selectors.getFilterForm)(state, formId);
          filterType = form[_component.PROPS.FILTER_TYPE];
          filterParams = form[_component.PROPS.FILTER_PARAMS];
          preloadFields = (0, _selectors2.getFormFields)(state, formId);

          if (!(filterParams !== undefined)) {
            _context2.next = 16;
            break;
          }

          _context2.next = 16;
          return (0, _effects.put)((0, _actions.apply)(filterType, filterParams));

        case 16:
          if (!preloadFields) {
            _context2.next = 19;
            break;
          }

          _context2.next = 19;
          return (0, _effects.call)(_saga.preloadFieldsOptions, preloadFields);

        case 19:
          _context2.next = 21;
          return (0, _effects.put)((0, _actions2.fieldsPreloadComplete)(formId));

        case 21:
          _context2.next = 23;
          return (0, _effects.put)((0, _actions.preloadComplete)([filterType], true));

        case 23:
          if (!(action.type === filterValueTypes.SET || action.type === filterValueTypes.APPLY || action.type === filterValueTypes.RESET)) {
            _context2.next = 28;
            break;
          }

          return _context2.delegateYield(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee() {
            var filterType, state, updatedFieldNames, preloadFields, preloadFilterTypes, filterForms, relatedFilterForms, abortController;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!(action.type === filterValueTypes.APPLY && action.payload.isViewUpdateRequired == false)) {
                      _context.next = 2;
                      break;
                    }

                    return _context.abrupt("return", "continue");

                  case 2:
                    filterType = action.payload.filterType;
                    _context.next = 5;
                    return (0, _effects.select)();

                  case 5:
                    state = _context.sent;
                    updatedFieldNames = _lodash["default"].keys(action.payload.value);
                    preloadFields = [];
                    preloadFilterTypes = []; // Take all filter form fields

                    filterForms = (0, _selectors.getFilterFormByFilterType)(state, filterType);

                    _lodash["default"].forEach(filterForms, function (filterForm) {
                      preloadFilterTypes = preloadFilterTypes.concat(filterForm[_component.PROPS.FILTER_TYPE]);
                      preloadFields = preloadFields.concat((0, _selectors2.getFieldsByFilterType)(state, filterForm[_component.PROPS.FILTER_TYPE]));
                    }); // Take all related filter form fields


                    relatedFilterForms = (0, _selectors.getRelatedFilterFormByFilterType)(state, filterType);

                    _lodash["default"].forEach(relatedFilterForms, function (filterForm) {
                      preloadFilterTypes = preloadFilterTypes.concat(filterForm[_component.PROPS.FILTER_TYPE]);
                      preloadFields = preloadFields.concat((0, _selectors2.getFieldsByFilterType)(state, filterForm[_component.PROPS.FILTER_TYPE]));
                    }); // Exclude update filters


                    preloadFields = _lodash["default"].uniq(preloadFields.filter(function (field) {
                      return !updatedFieldNames.includes(field[_component.PROPS.FIELD_NAME]);
                    }));
                    abortController = new AbortController();
                    _context.next = 17;
                    return (0, _effects.call)(_saga.preloadFieldsOptions, preloadFields, abortController);

                  case 17:
                    _context.next = 19;
                    return (0, _effects.put)((0, _actions.preloadComplete)(preloadFilterTypes, false, abortController));

                  case 19:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          })(), "t0", 25);

        case 25:
          _ret = _context2.t0;

          if (!(_ret === "continue")) {
            _context2.next = 28;
            break;
          }

          return _context2.abrupt("continue", 0);

        case 28:
          if (!(action.type === _types4.ENABLE || action.type === _types4.DISABLE)) {
            _context2.next = 44;
            break;
          }

          _context2.next = 31;
          return (0, _effects.select)();

        case 31:
          _state = _context2.sent;
          reloadFilterForms = (0, _selectors.getAllFilterForms)(_state);
          filterTypes = _lodash["default"].uniq(reloadFilterForms.map(function (form) {
            return form.filterType;
          })); // ... preload all form fields

          i = 0;

        case 35:
          if (!(i < reloadFilterForms.length)) {
            _context2.next = 42;
            break;
          }

          reloadFields = (0, _selectors2.getFormFields)(_state, reloadFilterForms[i][_component.PROPS.ID]);
          _context2.next = 39;
          return (0, _effects.call)(_saga.preloadFieldsOptions, reloadFields);

        case 39:
          i++;
          _context2.next = 35;
          break;

        case 42:
          _context2.next = 44;
          return (0, _effects.put)((0, _actions.preloadComplete)(filterTypes));

        case 44:
          _context2.next = 0;
          break;

        case 46:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked);
}

var filtersSagas = [preloadValueFlow];
exports.filtersSagas = filtersSagas;